"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElements = exports.getEvents = void 0;
var is_function_1 = require("../is-function");
var is_element_1 = require("../is-element");
var isWindow = function (x) { return !!x && x === x.window; };
var isDocument = function (x) { return !!x && x.nodeType === 9; };
var getEvents = function (events) {
    if (events.trim() === '*') {
        var types = [];
        for (var ev in window) {
            if (/^on/.test(ev)) {
                types[types.length] = ev;
            }
        }
        return types;
    }
    return events.split(' ').map(function (event) { return event.trim(); });
};
exports.getEvents = getEvents;
function arrayFrom(arrayLike) {
    var l = arrayLike.length;
    var arr = [];
    for (var i = 0; i < l; i++) {
        arr.push(arrayLike[i]);
    }
    return arr;
}
var getElements = function (elements) {
    var _elements = !!(elements && is_function_1.isFunction(elements.addEventListener))
        ? [elements]
        : Array.isArray(elements) ? elements : arrayFrom(elements);
    return _elements.filter(function (element) {
        return !(!isWindow(element) && !is_element_1.isElement(element) && !isDocument(element));
    });
};
exports.getElements = getElements;
//# sourceMappingURL=utils.js.map